// material-ui
import { useTheme } from '@mui/material/styles';

import logoIcon from 'assets/images/logo.png';
import zigna_aiIcon from '../../assets/images/zignaai_logo.png';
import prodLogo from 'assets/images/logo_sutherland.png';
import { ThemeMode } from 'config';
// ==============================|| LOGO ICON SVG ||============================== //

const LogoIcon = () => {
  const theme = useTheme();
  const isProd = import.meta.env.VITE_ENVIRONMENT === 'PROD';
  const logoSrc = isProd ? prodLogo : zigna_aiIcon;

  return <img src={logoSrc} alt="RightPx" width="50" />;
};

export default LogoIcon;
